import { useContext } from "react";

//Common
import FormBackGround from "../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../common/Forms/FormHeader/FormHeader";
import DisplayData from "../common/DisplayData/DisplayData";
import { BlockIcon, ActivateIcon } from "../common/Icons";
import { Button } from "../common/VFX-UI";
//App
import { EmployeeContext } from "./EmployeeContainer";
import useComponentGeneralStyles from "../styles";
import { EMPTY_GUID } from "../../utility/constants/constants";
import { OrganizationEmployeeViewProps } from "../../types/organizationEmployee";
import { Label } from "reactstrap";
import { employeeStatus } from "./constants";
import { getFormattedDate } from "../../utility/helpers";

const EmployeeView = (props: OrganizationEmployeeViewProps) => {
  const {
    onClose,
    editAction,
    toggleActivateHandler,
    toggleDeactivateHandler,
  } = props;
  const employeeContext = useContext(EmployeeContext);
  const generalStyles = useComponentGeneralStyles();

  const employee = employeeContext?.data;

  const isActive = employee?.statusId === employeeStatus.active;

  const hasManageEmployeesPermission =
    employeeContext?.hasManageEmployeesPermission;

  return (
    <FormBackGround>
      <FormHeader
        title={`${employee?.lastName}, ${employee?.firstName}${
          employee?.mi ? " " + employee?.mi : ""
        }`}
        chipLabel={isActive ? "Active" : "Inactive"}
        onClose={onClose}
        editActionHandler={
          hasManageEmployeesPermission && isActive ? editAction : undefined
        }
      />
      <>
        <DisplayData
          text="Personnel Number"
          importedData={employee?.personnelNumber}
        />

        <Label
          style={generalStyles.sectionHeader}
          className="border-bottom my-3 pb-2"
        >
          Contact Information
        </Label>
        <DisplayData
          text="Email Address"
          importedData={employee?.emailAddress}
        />

        <Label
          style={generalStyles.sectionHeader}
          className="border-bottom my-3 pb-2"
        >
          Employment Information
        </Label>
        <DisplayData text="Type" importedData={employee?.type} />
        <DisplayData
          text="Work Personnel Area"
          importedData={employee?.workPersonnelArea}
        />
        <DisplayData
          text="Organization Unit"
          importedData={employee?.organizationUnitName}
        />
        <DisplayData
          text="Supervisor"
          importedData={employee?.supervisorName}
        />
        <DisplayData
          text="Domain Lan Id"
          importedData={employee?.domainLanId}
        />
        {/* <DisplayData text="Status" importedData={employee?.status} /> */}
        <DisplayData
          text="Step-Up Enrollment Date"
          importedData={getFormattedDate(employee?.stepUpEnrollmentDate)}
        />
        <DisplayData
          text="Leadership Enrollment Date"
          importedData={getFormattedDate(employee?.leadershipEnrollmentDate)}
        />
      </>
      <div className="border-top container-fluid p-3 mt-auto">
        {hasManageEmployeesPermission &&
          employee?.id &&
          employee?.id !== EMPTY_GUID &&
          !isActive && (
            <Button
              style={generalStyles.activateButton}
              onClick={toggleActivateHandler}
            >
              <ActivateIcon />
            </Button>
          )}
        {hasManageEmployeesPermission &&
          employee?.id &&
          employee?.id !== EMPTY_GUID &&
          isActive && (
            <Button
              style={generalStyles.deleteButton}
              onClick={toggleDeactivateHandler}
            >
              <BlockIcon />
            </Button>
          )}
      </div>
    </FormBackGround>
  );
};

export default EmployeeView;
